import React, { useState, useEffect } from "react";
import { AssessmentTemplate } from "./assessment-templete";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import api from "../../../axiosconfig.js";
import useAssessmentReport, { REPORT_FIELDS } from "../../../hooks/assessment/useAssessmentReport";

export const MainPage = () => {
  const { metadata, analysis, scores, loading, error, reload } = useAssessmentReport();
  const [name, setName] = useState("");

  useEffect(() => {
    let active = true;
    api.post(`${process.env.REACT_APP_API_URL}/dataRequest`, { request: "getUserName" })
      .then(({ data }) => { if (active) setName(data?.name ? `${data.name}, ` : ""); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const summaries = REPORT_FIELDS.slice(0, 6).map((field) => analysis?.[field] || "");
  const date = metadata?.assessmentDate
    ? new Date(metadata.assessmentDate).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
    : "";
  const notices = [];
  if (metadata?.basis === "scores") notices.push("Individual questions are unavailable for this assessment. This is a limited score summary.");
  if (metadata?.basis === "limited_answers") notices.push("Some individual questions are unavailable. The reflection is limited to the recorded answers that can be identified.");
  if (metadata?.generation === "basic" && metadata?.basis !== "scores") notices.push("This is a basic reflection of your recorded answers.");

  return (
    <AssessmentTemplate
      headerTitle="PEARLI Assessment Summary"
      headerSubtitle="Reflect on your well-being, one domain at a time"
      breadcrumbs={[
        { icon: faHouse, text: "Self Mindfulness" },
        { icon: faHouse, text: "PEARLI (General Life)" },
        { text: "Summary Report", active: true },
      ]}
      tags={["Physical", "Emotional", "Acceptance", "Relationship", "Loving Kindness", "Intellectual"]}
      title={name + "Here’s your PEARLI Assessment Summary"}
      subtitle={`A reflection across six dimensions${date ? ` | ${date}` : ""}`}
      scores={scores}
      complete={Boolean(metadata?.complete)}
      reportNotice={notices.join(" ")}
      summaries={summaries}
      overAll={error || (loading ? "Preparing your assessment reflection..." : analysis?.GeneralSummary || "")}
      onRetry={error ? reload : undefined}
    />
  );
};
